import './Hardware.scss'

const Hardware  = () => {
    return (
        <h1>Hardware</h1>
    )
}

export default Hardware